import React, { useState } from "react";
import api from "../utils/api";
import { URLS } from "../utils/urls";
import { Send, Bell, Loader2 } from "lucide-react";
import Alert from "../components/Alert";

const Notifications = () => {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);

  const handleSend = async (e) => {
    e.preventDefault();
    if (!title || !body) {
      setAlert({ message: "Please fill in all fields", type: "error" });
      return;
    }

    try {
      setLoading(true);
      const res = await api.post(URLS.BULK_NOTIFICATIONS, { title, body });
      setAlert({ message: res.data.message || "Notification sent successfully", type: "success" });
      setTitle("");
      setBody("");
    } catch (err) {
      setAlert({ message: err.response?.data?.message || "Failed to send notification", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="bg-white rounded-2xl p-8 shadow-md border border-gray-100">
        <div className="flex items-center gap-3 mb-6">
          <div className="p-3 bg-[#db8654]/10 text-[#db8654] rounded-xl">
            <Bell size={24} />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Push Notifications</h2>
            <p className="text-gray-500 text-sm">Send a message to all users with FCM tokens</p>
          </div>
        </div>

        <form onSubmit={handleSend} className="space-y-6">
          <div className="space-y-2">
            <label className="text-sm font-semibold text-gray-700 ml-1">Title</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="e.g. New Event Tomorrow! 🎉"
              className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#db8654] outline-none transition"
            />
          </div>

          <div className="space-y-2">
            <label className="text-sm font-semibold text-gray-700 ml-1">Message Body</label>
            <textarea
              value={body}
              onChange={(e) => setBody(e.target.value)}
              placeholder="Enter your message details here..."
              rows={5}
              className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#db8654] outline-none transition resize-none"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#db8654] text-white py-4 rounded-xl font-bold hover:bg-[#c47345] transition flex items-center justify-center gap-2 disabled:opacity-50 shadow-lg shadow-[#db8654]/20"
          >
            {loading ? (
              <Loader2 className="animate-spin" size={20} />
            ) : (
              <Send size={20} />
            )}
            {loading ? "Sending..." : "Send to All Users"}
          </button>
        </form>
      </div>

      {alert && (
        <Alert
          message={alert.message}
          type={alert.type}
          onClose={() => setAlert(null)}
        />
      )}

      <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-r-xl">
        <p className="text-sm text-blue-700 italic">
          Tip: Use emojis to increase engagement. Notifications are sent via Firebase Cloud Messaging.
        </p>
      </div>
    </div>
  );
};

export default Notifications;
